import { Outlet, ScrollRestoration } from 'react-router-dom'
import { PageLayout } from './PageLayout'
import { PublicNavbar } from './PublicNavbar'
import { PublicFooter } from './PublicFooter'
import { PageTransitionProvider } from '@/context/PageTransitionContext'
import { PageTransitionOverlay } from '@/components/common/PageTransitionOverlay'
import { CartDrawer } from '@/features/shop'

export function PublicLayout() {
  return (
    <PageTransitionProvider>
      <PageTransitionOverlay />
      <PageLayout header={<PublicNavbar />} footer={<PublicFooter />} stickyHeader>
        <ScrollRestoration />
        <Outlet />
      </PageLayout>
      <CartDrawer />
    </PageTransitionProvider>
  )
}
